import { Tooltip } from 'antd';
import type { UploadRow } from '@/models/upload';
import {
  aiProductStates,
  uploadBadgeVariant,
  uploadStatusLabel,
  uploadStatusTooltip,
} from '@/features/uploads/utils/uploadStatus';
import styles from './UploadStatusBadge.module.css';

interface UploadStatusBadgeProps {
  upload: UploadRow;
}

export default function UploadStatusBadge({ upload }: UploadStatusBadgeProps) {
  const badge = (
    <span className={styles.badge} data-variant={uploadBadgeVariant(upload)}>
      {uploadStatusLabel(upload)}
    </span>
  );

  const tooltip = uploadStatusTooltip(upload);
  const products = aiProductStates(upload);
  return (
    <>
      {tooltip ? <Tooltip title={tooltip}>{badge}</Tooltip> : badge}
      {products.length > 0 && (
        // AP-869: every product's state at once, scans may run in parallel.
        <ul className={styles.products} aria-label="AI products">
          {products.map(({ product, name, state }) => (
            <li key={product} className={styles.product} data-state={state}>
              {name} · {state}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
